import appSettings from "@configs/app.ts";

export const MAX_LENGTH = {
  CLASS_CODE: 250,
  CLASS_GROUP_NAME: 250,
};

export const CLASS_TYPE = {
  STANDARD: "S",
};

export const IMPORT_TYPE = {
  SB_SUBJECT_GROUP_IMPORT: {
    value: "SB_SUBJECT_GROUP_IMPORT",
    label: "import_type_sb_subject_group_import",
  },
  SB_STUDENT_SUBJECT_ALLOCATION: {
    value: "SB_STUDENT_SUBJECT_ALLOCATION",
    label: "import_type_sb_student_subject_allocation",
  },
  SB_TEACHER_SUBJECT_ALLOCATION: {
    value: "SB_TEACHER_SUBJECT_ALLOCATION",
    label: "import_type_sb_teacher_subject_allocation",
  },
};

export const IMPORT_TYPE_FILE = {
  SB_SUBJECT_GROUP_IMPORT: `${appSettings.vleDomain}/template/school-based-info-import/SampleClassTemplate.csv`,
  SB_STUDENT_SUBJECT_ALLOCATION: `${appSettings.vleDomain}/template/school-based-info-import/SampleStudentAllocationTemplate.csv`,
  SB_TEACHER_SUBJECT_ALLOCATION: `${appSettings.vleDomain}/template/school-based-info-import/SampleTeacherAllocationTemplate.csv`,
};

export const ADD_STUDENT_GROUP_FILTER_TAG_LABELS = [
  {
    formClasses: "search_filter_add_student_group_form_classes_label",
    levelStreams: "search_filter_add_student_group_level_streams_label",
    school: "search_filter_add_student_group_schools_label",
  },
];

export const FILE_SIZE_LIMIT = "10";
